import React from 'react'
import HomeBanner from "../components/HomeBanner"
import OverlappingCards from "../components/OverlappingCards"
import Separate from '../components/Separate'
import BeforeAfterSlider from "../components/BeforeAfterSlider"
import StickySection from "../components/StickySection"
import FaqSection from '../components/FaqSection'
import StayWithUs from '../components/StayWithUs'
import HomeAbout from '../components/HomeAbout'
import WhyDifferent from '../components/WhyDifferent'
import HomeProducts from '../components/HomeProducts'
import { Helmet } from 'react-helmet-async';

function Home() {
  return (
    
    <div>
<Helmet>
  <title>Best ACP Aluminium Composite Panels | Alutuff</title>
  <meta name="description" content="Premium ACP aluminium composite panels and wooden prime panels – durable, weather-resistant and stylish exterior cladding." />
  <link rel="canonical" href="https://alutuff.in/" />
</Helmet>

    <HomeBanner/>
   
    <HomeAbout/>
    <HomeProducts/>
    {/* <WhyDifferent/> */}
      {/* <SlidingImage/> */}
   <OverlappingCards/>
   {/* <Separate/> */}
   <BeforeAfterSlider/>
   <StickySection/>
   <FaqSection/>
   <div style={{marginBottom:"-5%"}}>

<StayWithUs/>
   </div>
    </div>
  )
}

export default Home
